import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/images/cod-logo.png'
import _imports_1 from '@/app/ui/assets/images/dfod-logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-55d0d06f")

_pushScopeId("data-v-55d0d06f")
const _hoisted_1 = {
  style: {"width":"42rem"},
  class: "relative edit-body overflow-y-auto"
}
const _hoisted_2 = { class: "font-semibold text-xl mt-3 text-gray-lp-300" }
const _hoisted_3 = { class: "flex flex-row w-full pt-8" }
const _hoisted_4 = { class: "flex flex-row w-full pt-5" }
const _hoisted_5 = { class: "w-1/2 pr-3" }
const _hoisted_6 = { class: "w-1/2 pl-3" }
const _hoisted_7 = { class: "flex flex-row w-full pt-5" }
const _hoisted_8 = {
  key: 2,
  class: "w-1/2 pl-3"
}
const _hoisted_9 = { class: "py-1.5" }
const _hoisted_10 = {
  key: 0,
  class: "pt-5"
}
const _hoisted_11 = { class: "w-full pt-5" }
const _hoisted_12 = { class: "w-full pt-5" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "w-6/12" }, null, -1)
const _hoisted_14 = { class: "flex flex-row w-full pt-5" }
const _hoisted_15 = { class: "w-1/2 pr-3" }
const _hoisted_16 = { class: "w-1/2 pl-3" }
const _hoisted_17 = {
  key: 2,
  class: "w-1/2 pt-5 pr-3"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_19 = { class: "flex justify-between" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-500" }, " Setiap barang yang dibooking oleh klien akan menyesuaikan dengan layanan yang telah dipilih. ", -1)
const _hoisted_22 = { class: "w-full flex flex-row pt-5" }
const _hoisted_23 = { class: "p-field-checkbox relative mr-32 flex flex-row" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { class: "ml-2.5 text-12px xxl:text-14px cursor-pointer" }, "COD", -1)
const _hoisted_25 = { class: "p-field-checkbox relative flex flex-row" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", { class: "ml-2.5 text-12px xxl:text-14px cursor-pointer" }, "Delivery Order", -1)
const _hoisted_27 = {
  key: 4,
  class: "w-full"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-xl mt-3 text-gray-lp-300" }, [
  /*#__PURE__*/_createTextVNode(" Layanan COD & Delivery Order "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", {
    class: "text-gray-lp-500 font-normal",
    style: {"font-size":"0.85rem"}
  }, " Setiap barang yang dibooking oleh klien akan menyesuaikan dengan layanan yang telah dipilih. ")
], -1)
const _hoisted_30 = { class: "w-full flex flex-row pt-5" }
const _hoisted_31 = { class: "p-field-checkbox relative mr-32 flex flex-row" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5 text-12px xxl:text-14px cursor-pointer",
  for: "clientIsCod"
}, "COD", -1)
const _hoisted_33 = { class: "p-field-checkbox relative flex flex-row" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5 text-12px xxl:text-14px cursor-pointer",
  for: "clientDeliveryOrder"
}, "Delivery Order", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "py-8" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_36 = { class: "space-y-6" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "py-8" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_38 = { class: "flex w-full bg-gray-lp-200 p-4 pl-6 my-6 rounded-md text-black-lp-300" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "w-full pt-2" }, [
  /*#__PURE__*/_createVNode("p", null, "Sama dengan detail Cabang Klien")
], -1)
const _hoisted_40 = { class: "w-2/12 pl-6" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_42 = { class: "space-y-3 pt-3" }
const _hoisted_43 = { class: "flex justify-between gap-x-8 w-full" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center gap-x-2 mt-4" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "max-w-none w-16",
    alt: "cod-logo"
  }),
  /*#__PURE__*/_createVNode("p", { class: "text-14px font-medium" }, "Cash on delivery")
], -1)
const _hoisted_47 = { class: "flex flex-row bg-gray-lp-1200 p-4 rounded-md text-14px w-3/4 mt-3" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_49 = {
  key: 1,
  class: "p-field-checkbox mt-3 space-x-4 flex flex-row items- my-2"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "max-w-none w-16",
  alt: "cod-logo"
}, null, -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("label", { for: "cod" }, "Delivery fee on delivery", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_53 = { class: "grid grid-cols-2 gap-8" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_55 = {
  key: 5,
  class: "w-full"
}
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-xl mt-3 text-gray-lp-300" }, " Detail Induk Client ", -1)
const _hoisted_58 = { class: "flex flex-row w-full pt-8" }
const _hoisted_59 = { class: "w-1/2 pr-3" }
const _hoisted_60 = { class: "w-1/2 pl-3" }
const _hoisted_61 = { class: "flex flex-row w-full pt-5" }
const _hoisted_62 = { class: "w-1/2 pr-3" }
const _hoisted_63 = { class: "w-1/2 pl-3" }
const _hoisted_64 = { class: "py-1.5" }
const _hoisted_65 = { class: "w-1/2 pr-3" }
const _hoisted_66 = { class: "py-1.5" }
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-xl mt-3 text-gray-lp-300" }, " Informasi Kontak ", -1)
const _hoisted_69 = { class: "flex flex-row w-full pt-8" }
const _hoisted_70 = { class: "w-1/2 pr-3" }
const _hoisted_71 = { class: "w-1/2 pl-3" }
const _hoisted_72 = { class: "flex flex-row w-full pt-5" }
const _hoisted_73 = { class: "w-1/2 pr-3" }
const _hoisted_74 = { class: "w-1/2 pl-3" }
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_76 = { class: "flex flex-row gap-x-8 w-full py-5" }
const _hoisted_77 = {
  key: 7,
  class: "space-y-3"
}
const _hoisted_78 = { class: "flex flex-row justify-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_TaxSection = _resolveComponent("TaxSection")!
  const _component_Title = _resolveComponent("Title")!
  const _component_ToggleV2 = _resolveComponent("ToggleV2")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DetailDeliveryOrder = _resolveComponent("DetailDeliveryOrder")!
  const _component_lp_radio = _resolveComponent("lp-radio")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_BillingSection = _resolveComponent("BillingSection")!
  const _component_BankSection = _resolveComponent("BankSection")!
  const _component_BankSettlementSection = _resolveComponent("BankSettlementSection")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      footer: true,
      modelValue: _ctx.show,
      persistent: true,
      title: "Ubah Client",
      class: "edit-detail-form",
      "onUpdate:modelValue": _cache[42] || (_cache[42] = 
      () => {
        _ctx.emit('update:show', false);
        _ctx.showCloseConfirmModal = true;
        _ctx.back = false;
      }
    )
    }, {
      footer: _withId(() => [
        _createVNode("div", _hoisted_78, [
          _createVNode(_component_button_fill, {
            isDisabled: !_ctx.isEditDetailInvalid || _ctx.anyFormError,
            onClick: _cache[41] || (_cache[41] = 
            () => {
              _ctx.emit('update:show', false);
              _ctx.showConfirmModal = true;
            }
          ),
            title: "Simpan",
            class: "bg-red-lp-300",
            style: {"width":"135px"}
          }, null, 8, ["isDisabled"])
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.modelValue.clientType.toLowerCase() === "induk client"
            ? "Detail Induk Client"
            : "Detail Cabang Client"), 1),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              label: "Tipe Client",
              class: "w-1/2 pr-3"
            }, {
              default: _withId(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.modelValue.clientType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.clientType = $event)),
                  placeholder: "Tipe Client",
                  disabled: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.modelValue.clientType.toLowerCase() === 'induk client')
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  label: "Odoo ID",
                  class: "w-1/2 pl-3"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.modelValue.clientOdooId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue.clientOdooId = $event)),
                      placeholder: "Tipe Client",
                      disabled: true
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_DataWrapper, { label: "ID Client" }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.modelValue.clientId,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.clientId = $event)),
                    placeholder: "Masukan nama Client",
                    disabled: true
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_DataWrapper, { label: "Kode Client" }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.modelValue.clientCode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelValue.clientCode = $event)),
                    placeholder: "Masukan kode Client",
                    disabled: true
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            (_ctx.modelValue.clientType.toLowerCase() === 'induk client')
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: 
            _ctx.modelValue.clientType.toLowerCase() === 'induk client'
              ? 'w-1/2 pr-3'
              : 'w-full'
          
                }, [
                  _createVNode(_component_DataWrapper, {
                    label: "Nama Induk Client",
                    asterisk: ""
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.modelValue.clientName,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.clientName = $event)),
                        placeholder: "Masukan nama client"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ], 2))
              : (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: 
            _ctx.modelValue.clientType.toLowerCase() === 'induk client'
              ? 'w-1/2 pr-3'
              : 'w-full'
          
                }, [
                  _createVNode(_component_DataWrapper, {
                    label: "Nama Cabang Client",
                    asterisk: ""
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.modelValue.clientName,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.modelValue.clientName = $event)),
                        placeholder: "Masukan nama client",
                        onChange: _ctx.fullFilledCodReceiver
                      }, null, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  })
                ], 2)),
            (_ctx.modelValue.clientType.toLowerCase() === 'induk client')
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode(_component_DataWrapper, { label: "Kategori Client" }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_9, [
                        _createVNode(_component_Select, {
                          onOpenSelect: _ctx.onOpenSelectClientCategory,
                          onCloseSelect: _ctx.onCloseSelectClientCategory,
                          isOpenMenu: _ctx.isOpenClientCategory,
                          value: _ctx.modelValue.clientCategory,
                          onChooseSelect: _ctx.onSelectClientCategory,
                          dataSelect: _ctx.clientCategoryList,
                          class: "w-full whitespace-no-wrap z-10",
                          style: {"margin":"0"}
                        }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.modelValue.clientType.toLowerCase() === 'induk client')
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode(_component_DataWrapper, {
                  label: "Company Size",
                  class: "w-1/2",
                  asterisk: ""
                }, {
                  default: _withId(() => [
                    _createVNode(_component_Select, {
                      onOpenSelect: _ctx.onOpenSelectCompanySize,
                      onCloseSelect: _ctx.onCloseSelectCompanySize,
                      isOpenMenu: _ctx.isOpenCompanySize,
                      value: _ctx.modelValue.clientCompanySize,
                      onChooseSelect: _ctx.onSelectCompanySize,
                      dataSelect: _ctx.companySizeList,
                      class: "w-full whitespace-no-wrap my-2"
                    }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_DataWrapper, {
              label: "Alamat",
              asterisk: ""
            }, {
              default: _withId(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.modelValue.clientAddress,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.modelValue.clientAddress = $event)),
                  placeholder: "Masukan alamat Client",
                  type: "textarea",
                  onChange: _ctx.fullFilledCodAddressReceiver
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_DataWrapper, {
              label: "Kecamatan, Kota",
              class: "w-1/2 pr-3",
              asterisk: ""
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectSearch, {
                  class: "my-1",
                  onFilter: _ctx.fetchDistrictList,
                  isLoading: _ctx.loadingDistrictList,
                  options: _ctx.districtList,
                  keyName: "name",
                  keyValue: "code",
                  placeholder: "Ketik atau pilih lokasi",
                  modelValue: _ctx.modelValue.clientDistrict,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.modelValue.clientDistrict = $event)),
                  onChange: _ctx.fullFilledCodDistrict
                }, null, 8, ["onFilter", "isLoading", "options", "modelValue", "onChange"])
              ]),
              _: 1
            }),
            _hoisted_13
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_DataWrapper, {
                label: "Email",
                asterisk: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.modelValue.clientEmail,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.modelValue.clientEmail = $event)),
                    placeholder: "e.g email@gmail.com",
                    type: "email",
                    error: _ctx.errorFormEmail,
                    errorCaption: "Masukan Email dengan benar"
                  }, null, 8, ["modelValue", "error"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode(_component_DataWrapper, {
                label: "No. Telepon",
                asterisk: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_SelectPhoneCountry, {
                    phone: _ctx.modelValue.clientPhone,
                    code: _ctx.clientPhoneDialCode,
                    error: _ctx.errorPhoneMainEdit,
                    column: "Kontak",
                    placeholder: "81119600999",
                    onSetPhone: _ctx.onSetClientPhone,
                    onSetPhoneCode: _cache[10] || (_cache[10] = v => (_ctx.clientPhoneDialCode = v))
                  }, null, 8, ["phone", "code", "error", "onSetPhone"])
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.modelValue.clientType.toLowerCase() === 'induk client')
            ? (_openBlock(), _createBlock(_component_TaxSection, {
                key: 1,
                form: _ctx.modelValue.clientTax,
                error: _ctx.error,
                type: "edit",
                styleWrapper: "w-full pt-5 pb-2"
              }, null, 8, ["form", "error"]))
            : (_openBlock(), _createBlock("div", _hoisted_17, [
                _createVNode(_component_DataWrapper, { label: "No. Registrasi Pajak (NPWP)" }, {
                  default: _withId(() => [
                    _createVNode(_component_lp_input, {
                      format: _ctx.formatNPWP,
                      modelValue: _ctx.modelValue.clientNpwp,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.modelValue.clientNpwp = $event)),
                      placeholder: "00.000.000.0-000.000",
                      maxLength: 20,
                      showMaxLength: true,
                      error: _ctx.errorFormNPWP,
                      errorCaption: "Masukan No. Registrasi Pajak (NPWP) dengan benar"
                    }, null, 8, ["format", "modelValue", "error"])
                  ]),
                  _: 1
                })
              ])),
          (_ctx.modelValue.clientType.toLowerCase() !== 'induk client')
            ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                _hoisted_18,
                _createVNode("div", _hoisted_19, [
                  _createVNode(_component_Title, {
                    label: "Konfigurasi retur",
                    class: "mt-1"
                  }),
                  _createVNode(_component_ToggleV2, {
                    onClick: _cache[12] || (_cache[12] = () => _ctx.toggleReturnConfig()),
                    "model-value": _ctx.modelValue.isReturnConfig,
                    "style-active": _ctx.toggle-_ctx.active
                  }, null, 8, ["model-value", "style-active"])
                ]),
                (_ctx.modelValue.isReturnConfig)
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 0,
                      label: "Batas konfirmasi retur",
                      optional: ""
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_LpInput, {
                          modelValue: _ctx.modelValue.returnConfigLimit,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.modelValue.returnConfigLimit = $event)),
                          placeholder: "Batas konfirmasi retur",
                          "max-length": 3,
                          suffix: "hari"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.modelValue.isReturnConfig)
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 1,
                      label: "Alasan retur perlu dikonfirmasi",
                      optional: ""
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_MultipleSelectSearch, {
                          options: _ctx.reasonList,
                          modelValue: _ctx.returnConfigReasonIds,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.returnConfigReasonIds = $event)),
                          modalTitle: "Return Reason List",
                          keyName: "name",
                          keyValue: "value",
                          placeholder: "Pilih alasan",
                          "custom-display-all": "Semua alasan",
                          onFilter: _ctx.onSearchAddObject,
                          class: "py-2"
                        }, null, 8, ["options", "modelValue", "onFilter"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _hoisted_20,
                _createVNode(_component_Title, { label: "Layanan Pengiriman" }),
                _hoisted_21,
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _createVNode(_component_Checkbox, {
                      id: "clientIsCod",
                      modelValue: _ctx.modelValue.clientIsCod,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.modelValue.clientIsCod = $event)),
                      onChange: _cache[16] || (_cache[16] = ()=> {!_ctx.modelValue.clientIsCod ? _ctx.modelValue.clientIsDfod = false : null}),
                      binary: true
                    }, null, 8, ["modelValue"]),
                    _hoisted_24
                  ]),
                  _createVNode("div", _hoisted_25, [
                    _createVNode(_component_Checkbox, {
                      id: "clientDeliveryOrder",
                      modelValue: _ctx.modelValue.clientIsDo,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.modelValue.clientIsDo = $event)),
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.modelValue.clientBranchDoPaymentType = '')),
                      binary: true
                    }, null, 8, ["modelValue"]),
                    _hoisted_26
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.modelValue.clientType.toLowerCase() !== 'induk client')
            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                _hoisted_28,
                _hoisted_29,
                _createVNode("div", _hoisted_30, [
                  _createVNode("div", _hoisted_31, [
                    _createVNode(_component_Checkbox, {
                      id: "clientIsCod",
                      modelValue: _ctx.modelValue.clientIsCod,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.modelValue.clientIsCod = $event)),
                      binary: true,
                      onChange: _cache[20] || (_cache[20] = ()=> {!_ctx.modelValue.clientIsCod ? _ctx.detailClient.clientIsDfod = false : null})
                    }, null, 8, ["modelValue"]),
                    _hoisted_32
                  ]),
                  _createVNode("div", _hoisted_33, [
                    _createVNode(_component_Checkbox, {
                      id: "clientDeliveryOrder",
                      modelValue: _ctx.modelValue.clientIsDeliveryOrder,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.modelValue.clientIsDeliveryOrder = $event)),
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.modelValue.clientBranchDoPaymentType = '')),
                      binary: true
                    }, null, 8, ["modelValue"]),
                    _hoisted_34
                  ])
                ]),
                (
            _ctx.modelValue.clientIsDeliveryOrder &&
              _ctx.modelValue.clientType.toLowerCase() !== 'induk client'
          )
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_35,
                      _createVNode("div", _hoisted_36, [
                        _createVNode(_component_DetailDeliveryOrder, {
                          detailData: _ctx.modelValue,
                          isForm: ""
                        }, null, 8, ["detailData"])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (
            _ctx.modelValue.clientIsCod &&
              _ctx.modelValue.clientType.toLowerCase() !== 'induk client'
          )
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_37,
                      _createVNode(_component_Title, { label: "Pengembalian STT return" }),
                      _createVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createVNode("div", _hoisted_40, [
                          _createVNode("div", {
                            onClick: _cache[23] || (_cache[23] = () => _ctx.autoFill()),
                            class: 
                  `toggle-switch inline-block cursor-pointer ${
                    _ctx.isFill ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
                  }`
                
                          }, [
                            _hoisted_41
                          ], 2)
                        ])
                      ]),
                      _createVNode("div", _hoisted_42, [
                        _createVNode(_component_Title, {
                          label: "Detail Penerima",
                          class: "mb-6 mt-2"
                        }),
                        _createVNode(_component_DataWrapper, {
                          label: "Nama Penerima",
                          class: "w-full pt-2"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_lp_input, {
                              modelValue: _ctx.detailClient.clientCodReject.clientCodName,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.detailClient.clientCodReject.clientCodName = $event)),
                              placeholder: "Masukan nama penerima",
                              disabled: _ctx.autoFillColumnDisabled
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DataWrapper, {
                          label: "Alamat Penerima",
                          class: "w-full"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_lp_input, {
                              type: "textarea",
                              modelValue: _ctx.detailClient.clientCodReject.clientCodAddress,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.detailClient.clientCodReject.clientCodAddress = $event)),
                              placeholder: "Masukan alamat penerima",
                              disabled: _ctx.autoFillColumnDisabled
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode("div", _hoisted_43, [
                          _createVNode(_component_DataWrapper, {
                            label: "Kecamatan, Kota",
                            class: "w-6/12"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_SelectSearch, {
                                class: "my-1",
                                onFilter: _ctx.fetchDistrictList,
                                isLoading: _ctx.loadingDistrictList,
                                options: _ctx.districtList,
                                error: _ctx.error.codRejdistrict,
                                keyName: "name",
                                keyValue: "id",
                                placeholder: "Ketik atau pilih lokasi",
                                modelValue: _ctx.detailClient.clientCodReject.clientCodDistrict,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.detailClient.clientCodReject.clientCodDistrict = $event)),
                                isDisabled: _ctx.autoFillColumnDisabled
                              }, null, 8, ["onFilter", "isLoading", "options", "error", "modelValue", "isDisabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_DataWrapper, {
                            label: "No. Telepon",
                            class: "w-6/12"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_SelectPhoneCountry, {
                                phone: _ctx.detailClient.clientCodReject.clientCodPhone,
                                code: _ctx.codRejDialCode,
                                error: _ctx.errorCodRejPhoneEdit,
                                column: "Kontak",
                                placeholder: "81119600999",
                                disabled: _ctx.autoFillColumnDisabled,
                                onSetPhone: _ctx.onSetCodRejPhone,
                                onSetPhoneCode: _cache[27] || (_cache[27] = v => (_ctx.codRejDialCode = v))
                              }, null, 8, ["phone", "code", "error", "disabled", "onSetPhone"])
                            ]),
                            _: 1
                          })
                        ]),
                        _hoisted_44,
                        _createVNode(_component_Title, { label: "Tipe COD" }),
                        (_ctx.isEnableCodOngkir)
                          ? (_openBlock(), _createBlock("div", _hoisted_45, [
                              _hoisted_46,
                              _createVNode("div", _hoisted_47, [
                                _createVNode(_component_lp_radio, {
                                  name: "cod",
                                  options: _ctx.clientCodConfigAmountDataValue,
                                  labels: _ctx.clientCodConfigAmountDataName,
                                  modelValue: _ctx.detailClient.clientCodConfigAmount.value,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.detailClient.clientCodConfigAmount.value = $event))
                                }, null, 8, ["options", "labels", "modelValue"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_48,
                        (_ctx.isEnableCodOngkir)
                          ? (_openBlock(), _createBlock("div", _hoisted_49, [
                              _createVNode(_component_Checkbox, {
                                id: "cod",
                                modelValue: _ctx.detailClient.clientIsDfod,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.detailClient.clientIsDfod = $event)),
                                onChange: ($event: any) => ({}),
                                binary: true
                              }, null, 8, ["modelValue"]),
                              _hoisted_50,
                              _hoisted_51
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_52,
                        _createVNode(_component_Title, {
                          label: "Biaya & persentase COD",
                          class: "pb-6"
                        }),
                        _createVNode("div", _hoisted_53, [
                          _createVNode(_component_DataWrapper, {
                            label: "Biaya COD",
                            icon: "info",
                            iconActive: "info-red",
                            tooltipDescription: "Biaya COD akan dipotong dari jumlah Biaya COD."
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_lp_input, {
                                format: _ctx.formatFloat,
                                modelValue: _ctx.detailClient.clientCodReject.clientCodCommissionPercentage,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.detailClient.clientCodReject.clientCodCommissionPercentage = $event)),
                                error: _ctx.errorCodCommission.error,
                                errorCaption: _ctx.errorCodCommission.caption,
                                placeholder: "e.g 20",
                                suffix: "%"
                              }, null, 8, ["format", "modelValue", "error", "errorCaption"])
                            ]),
                            _: 1
                          }),
                          (_ctx.isEnableCodOngkir)
                            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                                key: 0,
                                label: "Persentase Diskon COD",
                                icon: "info",
                                iconActive: "info-red",
                                tooltipTitle: "Info Persentase Diskon COD",
                                tooltipDescription: 
                  _ctx.clientCodShipmentDiscountTootltipDescription
                
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_lp_input, {
                                    format: _ctx.formatFloat,
                                    modelValue: _ctx.detailClient.clientCodShipmentDiscountPercentage,
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.detailClient.clientCodShipmentDiscountPercentage = $event)),
                                    error: _ctx.errorClientCodShipmentDiscount.error,
                                    errorCaption: _ctx.errorClientCodShipmentDiscount.caption,
                                    placeholder: "Masukkan persentase diskon COD",
                                    suffix: "%"
                                  }, null, 8, ["format", "modelValue", "error", "errorCaption"])
                                ]),
                                _: 1
                              }, 8, ["tooltipDescription"]))
                            : _createCommentVNode("", true),
                          (_ctx.isEnableCodBooking)
                            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                                key: 1,
                                label: "Biaya PAD",
                                class: "w-6/12",
                                icon: "info",
                                iconActive: "info-red",
                                tooltipDescription: "Biaya PAD akan ditambahkan ke Biaya PAD"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_lp_input, {
                                    format: _ctx.formatFloat,
                                    modelValue: _ctx.detailClient.clientPadFeePercentage,
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.detailClient.clientPadFeePercentage = $event)),
                                    error: _ctx.errorPadFee.error,
                                    errorCaption: _ctx.errorPadFee.caption,
                                    placeholder: "e.g 20",
                                    min: "0",
                                    max: "100",
                                    suffix: "%"
                                  }, null, 8, ["format", "modelValue", "error", "errorCaption"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_54
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.modelValue.clientType.toLowerCase() !== 'induk client')
            ? (_openBlock(), _createBlock("div", _hoisted_55, [
                _hoisted_56,
                _hoisted_57,
                _createVNode("div", _hoisted_58, [
                  _createVNode("div", _hoisted_59, [
                    _createVNode(_component_DataWrapper, {
                      label: "Nama Induk Client",
                      asterisk: ""
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_lp_input, {
                          modelValue: _ctx.modelValue.clientParentName,
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.modelValue.clientParentName = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_60, [
                    _createVNode(_component_DataWrapper, { label: "Nama Partner Pos" }, {
                      default: _withId(() => [
                        _createVNode(_component_SelectSearch, {
                          class: "my-1",
                          onFilter: _ctx.fetchPOSList,
                          onFocus: _ctx.fetchPOSList,
                          isLoading: _ctx.loadingPosList,
                          options: _ctx.posList,
                          keyName: "name",
                          keyValue: "id",
                          placeholder: "Ketik atau pilih POS",
                          modelValue: _ctx.modelValue.clientParentPos,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.modelValue.clientParentPos = $event))
                        }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode("div", _hoisted_61, [
                  _createVNode("div", _hoisted_62, [
                    _createVNode(_component_DataWrapper, {
                      label: "Komisi POS",
                      asterisk: ""
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_lp_input, {
                          format: _ctx.formatFloat,
                          modelValue: _ctx.modelValue.clientParentPOSCommision,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.modelValue.clientParentPOSCommision = $event)),
                          suffix: "%",
                          onChange: _ctx.validateErrorcommission,
                          error: _ctx.errorFormCommision.error,
                          errorCaption: _ctx.errorFormCommision.errorCaption
                        }, null, 8, ["format", "modelValue", "onChange", "error", "errorCaption"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_63, [
                    _createVNode(_component_DataWrapper, {
                      label: "Tipe Komisi",
                      asterisk: ""
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_64, [
                          _createVNode(_component_Select, {
                            onOpenSelect: _ctx.onOpenSelectCommissionType,
                            onCloseSelect: _ctx.onCloseSelectCommissionType,
                            isOpenMenu: _ctx.isOpenCommissionType,
                            onChooseSelect: _ctx.onSelectCommissionType,
                            dataSelect: _ctx.clientParentCommisionTypeList,
                            value: _ctx.modelValue.clientParentCommisionType,
                            class: "w-full whitespace-no-wrap",
                            style: {"margin":"0"}
                          }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "onChooseSelect", "dataSelect", "value"])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode("div", _hoisted_65, [
                  _createVNode(_component_DataWrapper, {
                    label: "Pembilang Komisi",
                    asterisk: ""
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_66, [
                        _createVNode(_component_Select, {
                          onOpenSelect: _ctx.onOpenSelectNumeratorCommision,
                          onCloseSelect: _ctx.onCloseSelectNumeratorCommision,
                          isOpenMenu: _ctx.isOpenSelectNumeratorCommision,
                          value: _ctx.modelValue.clientParentNumeratorCommision,
                          onChooseSelect: _ctx.onSelectNumeratorCommision,
                          dataSelect: _ctx.numeratorCommisionList,
                          class: "w-full whitespace-no-wrap z-10",
                          style: {"margin":"0"}
                        }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_67,
          _hoisted_68,
          _createVNode("div", _hoisted_69, [
            _createVNode("div", _hoisted_70, [
              _createVNode(_component_DataWrapper, {
                label: "Nama",
                asterisk: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.modelValue.clientContactName,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.modelValue.clientContactName = $event)),
                    placeholder: "Masukan nama"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_71, [
              _createVNode(_component_DataWrapper, {
                label: "Jabatan",
                asterisk: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.modelValue.clientContactJobTitle,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.modelValue.clientContactJobTitle = $event)),
                    placeholder: "Masukan jabatan"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("div", _hoisted_72, [
            _createVNode("div", _hoisted_73, [
              _createVNode(_component_DataWrapper, {
                label: "Email",
                asterisk: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.modelValue.clientContactEmail,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.modelValue.clientContactEmail = $event)),
                    placeholder: "e.g email@gmail.com",
                    type: "email",
                    error: _ctx.errorFormContactEmail,
                    errorCaption: "Masukan Email dengan benar"
                  }, null, 8, ["modelValue", "error"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_74, [
              _createVNode(_component_DataWrapper, {
                label: "No. Telepon",
                asterisk: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_SelectPhoneCountry, {
                    phone: _ctx.modelValue.clientContactPhone,
                    code: _ctx.clientContactDialCode,
                    error: _ctx.errorContactPhoneEdit,
                    column: "Kontak",
                    placeholder: "81119600999",
                    onSetPhone: _ctx.onSetClientContactPhone,
                    onSetPhoneCode: _cache[39] || (_cache[39] = v => (_ctx.clientContactDialCode = v))
                  }, null, 8, ["phone", "code", "error", "onSetPhone"])
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.isClientParent)
            ? (_openBlock(), _createBlock(_Fragment, { key: 6 }, [
                _hoisted_75,
                _createVNode(_component_Title, { label: "Informasi Pembayaran" }),
                _createVNode("div", _hoisted_76, [
                  _createVNode(_component_DataWrapper, {
                    class: "w-1/2",
                    label: "Metode Pembayaran",
                    asterisk: ""
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_CustomDropdown, {
                        modelValue: _ctx.detailClient.clientPaymentMethod,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.detailClient.clientPaymentMethod = $event)),
                        options: _ctx.clientPaymentMethodData,
                        placeholder: "Pilih metode pembayaran",
                        class: "w-full custom-select mt-1.5",
                        isCustomWidth: "",
                        selectedItem: _ctx.detailClient.clientPaymentMethod
                      }, null, 8, ["modelValue", "options", "selectedItem"])
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.modelValue.clientType.toLowerCase() === 'induk client')
            ? (_openBlock(), _createBlock("div", _hoisted_77, [
                _createVNode(_component_BillingSection, {
                  form: _ctx.modelValue.clientBilling,
                  back: _ctx.back,
                  error: _ctx.error,
                  type: "edit",
                  styleWrapper: "w-full pt-5"
                }, null, 8, ["form", "back", "error"]),
                _createVNode(_component_BankSection, {
                  type: "management",
                  isClearDefault: false
                }),
                _createVNode(_component_BankSettlementSection, {
                  type: "management",
                  isClearDefault: false
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      () => {
        _ctx.onSubmit();
        _ctx.back = false;
      }
    ,
      onClose: 
      () => {
        _ctx.back = true;
        _ctx.emit('update:show', true);
        _ctx.showConfirmModal = false;
      }
    ,
      title: "Konfirmasi Perubahan",
      message: 
      `Anda yakin ingin menyimpan perubahan Detail Client “${_ctx.modelValue.clientName}“?`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.showConfirmModal]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      () => {
        _ctx.setSuccessSubmit(false);
      }
    ,
      title: "Perubahan Berhasil Disimpan !",
      message: `Detail Client “${_ctx.modelValue.clientName}” berhasil diubah.`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.isSuccessSubmit]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: 
      () => {
        _ctx.back = true;
        _ctx.showCloseConfirmModal = false;
        _ctx.emit('update:show', true);
      }
    ,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.showCloseConfirmModal]
    ])
  ], 64))
})